
import React from "react";
import { StudentGeneralInformationView } from "../models/views/identity/StudentGeneralInformationView ";
export interface IAuthContext {
    isAuthenticated: boolean;
    hasContactUs: boolean;
    userInformation: StudentGeneralInformationView;
    pageUri: string;
}

export interface IUserInformation {
    userName: string;
}

const AuthContext = React.createContext<IAuthContext>({
    isAuthenticated: false,
    hasContactUs: false,
    userInformation: {
        education: {},
        personal: {},
        system: {},
    },
    pageUri:''
    // login: () => { },
    // logout: () => { }
});

export default AuthContext;